import { useState, useEffect, useRef } from 'react';
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import './information.css'
import axios from 'axios';

function Information() {
  const [arrAdvertisements, setArrAdvertisements] = useState([]);
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState("fade-in");

  const scrollRef = useRef(null);
  let currentLng = "es";
  localStorage.getItem("lng") ? currentLng = `${localStorage.getItem("lng")}` : currentLng = 'es';

  const triggerFade = (newIndex) => {
    setFade("fade-out");

    setTimeout(() => {
      setIndex(newIndex);
      setFade("fade-in");
    }, 250);
  };

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement`
      const response = await axios.get(url, {headers: {
        Authorization: process.env.REACT_APP_PUBLIC_KEY
      }});
      const advertisements = response.data.data.filter(item => item.type === "advertisement");
      setArrAdvertisements(advertisements);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (arrAdvertisements.length === 0) return;

    const interval = setInterval(() => {
      triggerFade((index + 1) % arrAdvertisements.length);
    }, 15000);

    return () => clearInterval(interval);
  }, [index, arrAdvertisements.length]);

  const prevSlide = () => {
    const newIndex = index === 0 ? arrAdvertisements.length - 1 : index - 1;
    triggerFade(newIndex);
  };

  const nextSlide = () => {
    const newIndex = (index + 1) % arrAdvertisements.length;
    triggerFade(newIndex);
  };

  useEffect(() => {
    if (arrAdvertisements.length === 0) return;

    const el = scrollRef.current;
    if (!el) return;

    el.scrollLeft = 0;

    // duración de 10s
    const duration = window.innerWidth < 600 ? 15000 : 10000;
    const start = el.scrollLeft;
    const end = el.scrollWidth - el.clientWidth;
    const startTime = performance.now();

    const animate = (time) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / duration, 1);

      el.scrollLeft = start + (end * progress);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [index, arrAdvertisements.length]);


  return(
    <>
      { arrAdvertisements.length === 0 ? (null) : (
        <div className='information-container-home'>
          <div className='arrow-left' onClick={prevSlide}><FiChevronLeft /></div>
          
            <div className={`info-text ${fade}`} ref={scrollRef}>
              {arrAdvertisements[index] && (
                <p className='title'>
                  {currentLng === "es" ? arrAdvertisements[index].title_es : arrAdvertisements[index].title_en} 
                  </p>
              )}

              {arrAdvertisements[index] && (
                <p>
                  {currentLng === "es" ? arrAdvertisements[index].desc_es : arrAdvertisements[index].desc_en}
                  </p>
              )}
            </div>
          <div className='arrow-right' onClick={nextSlide}><FiChevronRight /></div>
        </div>
      )}
    </>
  )
}

export default Information;